import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const SL_NO = "SL_NO";
export const DWNLD_FL = "DWNLD_FL";

export const translations = {
  en: {
    [SL_NO]: "Sl No.",
    [DWNLD_FL]: "Download File",
    [HEADING1]: "Annual Administration Report",
  },
  kn: {
    [SL_NO]: "ಕ್ರಮ ಸಂಖ್ಯೆ",
    [DWNLD_FL]: "ಫೈಲ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    [HEADING1]: "ವಾರ್ಷಿಕ ಆಡಳಿತ ವರದಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
